const LookupResultEnum = Object.freeze({
    UNKNOWN: "unknown",
    RESULT: "result",
    NORESULT: "noresult",
  });
  
  export default LookupResultEnum;